import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import Button from 'rebook/apps/base/components/Button';
import pluralize from 'rebook/apps/utils/text/pluralize';
import Form, { FormControl, FormRow } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import * as PaymentsActions from 'rebook/apps/payments/actions/PaymentsActions';

import styles from './style.scss';


const monthsMapper = {
  month: 1,
  months3: 3,
  year: 12,
};

const pluralizeNumberOfMonth = (monthsArray = []) => {
  if (monthsArray.length === 0) {
    return '';
  }

  const lastArrayElement = monthsArray[monthsArray.length - 1];

  return ` ${pluralize(monthsMapper[lastArrayElement], 'месяц', 'месяца', 'месяцев')}`;
};

const getPeriodsString = (periodsArray = []) => {
  if (periodsArray.length === 0) {
    return '';
  }

  let result = '', pluralMonth;

  if (periodsArray.length < 3) {
    for (let i = 0; i < periodsArray.length; i++) {
      let key = periodsArray[i];
      if (monthsMapper[key]) {
        pluralMonth = pluralizeNumberOfMonth(periodsArray);
        result += i > 0 ? ` и ${monthsMapper[key]}` : `${monthsMapper[key]}`;
      }
    }
  }
  else {
    return '';
  }
  return ` на ${result}${pluralMonth}`;
};

const getSubscriptionTypeString = (subscriptionsArray = [], periodsArray = [], isEmptyPeriod) => {
  if (subscriptionsArray.length === 0) {
    return '';
  }

  let result = '';
  let isAllSubscribeTypes = subscriptionsArray.includes('standard')
    && ((subscriptionsArray.includes('pro') || subscriptionsArray.includes('audio')));
  const subscriptionOnAllPeriods = !pluralizeNumberOfMonth[periodsArray] && isEmptyPeriod;
  const subscriptionsMapper = {
    standard: !subscriptionOnAllPeriods ? 'на стандартную подписку' : 'стандарта',
    pro: !subscriptionOnAllPeriods ? 'на премиум-подписку' : 'премиум-подписки',
    audio: !subscriptionOnAllPeriods ? 'на премиум-подписку' : 'премиум-подписки',
  };

  if (subscriptionsArray.length < 3 && !isAllSubscribeTypes) {
    for (let value of subscriptionsArray) {
      if (subscriptionsMapper[value]) {
        result = subscriptionsMapper[value];
      }
    }
  }
  else {
    return '';
  }

  return ` ${result}`;
};

const PromoCodeRedeemRestrictions = ({ redeemCode }) => {
  const { campaign } = redeemCode;

  const discountTypeString = campaign.discount_type === 'percent' ? '%' : ' ₽';
  const periodsString = getPeriodsString(campaign.subscription_periods);
  const discountAmountText = `Скидка ${campaign.discount}${discountTypeString}`;
  const minAmountOrderText = campaign.min_amount_order > 0
    ? ` при заказе от ${campaign.min_amount_order} ${pluralize(campaign.min_amount_order, 'рубля', 'рублей', 'рублей')}`
    : '';
  const subscriptionTypeText = getSubscriptionTypeString(
    campaign.subscription_types,
    campaign.subscription_periods,
    !!periodsString
  );
  const isAllSubscribeParameters = !subscriptionTypeText && !periodsString && !minAmountOrderText
    ? ' на любую подписку'
    : '';
  const result =`${discountAmountText}${periodsString}${subscriptionTypeText}` +
    `${isAllSubscribeParameters}${minAmountOrderText}`;

  return (
    <div className={styles.discountInfo}>
      <div className={styles.discountImage} />
      <small className={styles.restrictionText}>{result}</small>
    </div>
  );
};

class PaymentsPromoCodeDeactivateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      errorList: {},
      isInProgress: false,
    };
  }

  handleSubmit(submit) {
    this.setState({
      errorList: {},
      isInProgress: true,
    });

    const form = validateForm(this.state.form);
    submit(form);
  }

  handleSuccess() {
    const { PaymentsActions } = this.props;
    this.setState({
      errorList: {},
      isInProgress: false,
    }, () => {
      // remove the code on success as it had never existed
      PaymentsActions.updateRedeemCode(null, this.props.history);
    });
  }

  handleError(errorList) {
    this.setState({
      errorList,
      isInProgress: false,
    });
  }

  render() {
    const { errorList, isInProgress } = this.state;
    const { payments } = this.props;
    const { redeemCode } = payments;
    return (
      <div>
        <Form
          action={`/api/promocode/${redeemCode.code}/`}
          method="delete"
          extraClassName="jest-payments-promocode-deactivate-form"
          onSubmit={(callback) => this.handleSubmit(callback)}
          onSuccess={() => this.handleSuccess()}
          onError={(errorList) => this.handleError(errorList)}>
          <FormRow>
            <FormTextInput
              extraClassName="jest-payments-promocode-deactivate-form-code"
              validationMessageExtraClassName="jest-payments-promocode-deactivate-form-code-error"
              errorList={errorList.promocode || errorList.non_field_errors}
              isDisabled
              value={redeemCode.code}
              name="promocode" />
          </FormRow>
          <FormControl>
            <Button
              theme="secondary"
              size="small"
              extraClassName="jest-payments-promocode-delete-form-submit"
              isInProgress={isInProgress}>
              Удалить код
            </Button>
          </FormControl>
        </Form>
        <PromoCodeRedeemRestrictions redeemCode={redeemCode} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    payments: state.payments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    PaymentsActions: bindActionCreators(PaymentsActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentsPromoCodeDeactivateForm));
